var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/lorem/index.js
// module id = 1444
// module chunks = 1